import { module as modujs } from "modujs";

import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.gsapInstances = [];
	}

	init() {
		if (!sessionStorage.getItem("hasVisited")) {
			gsap.set(this.el, {
				autoAlpha: 1,
			});
		} else {
			this.el.classList.add("is-hidden");
		}

		sessionStorage.setItem("hasVisited", "true");

		this.$illustrations = this.$("illustration");
		this.$mask = this.$("mask")[0];

		this._loadHandler = this.load.bind(this);
		window.addEventListener("load", this._loadHandler);

		this.tl = gsap.timeline({ repeat: -1 });

		this.$illustrations.forEach((el, i) => {
			this.tl.set(el, { autoAlpha: 1 });
			this.tl.set(el, { autoAlpha: 0 }, `+=0.25`);
		});
	}

	load() {
		this.tl = gsap.timeline();

		this.tl.to(this.$mask, {
			scale: 0,
			rotate: 180,
			duration: 1.6,
			ease: "power3.inOut",
		});

		this.tl.to(
			this.$illustrations,
			{
				duration: 0.6,
				scale: 0,
				ease: "back.in(4)",
			},
			"<.4"
		);
	}

	destroy() {
		this.gsapInstances.forEach((instance) => {
			if (instance) {
				if (instance.scrollTrigger) {
					instance.scrollTrigger.kill();
				}
				instance.kill();
			}
		});
		this.gsapInstances = [];
	}
}
